module.exports = __webpack_public_path__ + "img/2200m.fddef1c0.png";